
import { Row, Col } from 'react-bootstrap';
import Product from './Product';
import { SHAPE_LIST } from './../../../enums/Enum';
import Img17 from "../../../assets/images/17.png"
import Img18 from "../../../assets/images/18.png"
import Img19 from "../../../assets/images/19.png"
import Img19J from "../../../assets/images/19.jpg"
import Img20 from "../../../assets/images/20.jpg"
import { dateFormatter } from '../../../helper/DateFormat';
import { Empty } from 'antd';




const Products = ({random, shape, products}) => {

    const dataProducts = [
        {
            id: 1,
          image: Img17,
          name: "Flower shape",
          price: {
            name: "USD",
            amount: 32,
            currency: 1,
          },
          created_at: '2024-01-29 19:29',
        },
        {
            id: 2,
            image: Img18,
            name: "Rose",
            price: {
              name: "USD",
              amount: 33,
              currency: 1,
            },
            created_at: '2024-01-29 19:30',
          },
          {
            id: 3,
            image: Img19,
            name: "zebra",
            price: {
              name: "USD",
              amount: 34,
              currency: 1,
            },
            created_at: '2024-01-29 19:31',
          },
          {
            id: 4,
              image: Img19J,
              name: "Tiger",
              price: {
                name: "USD",
                amount: 35,
                currency: 1,
              },
              created_at: '2024-01-29 19:32',
            },
            {
                id: 5,
                image: Img20,
                name: "Masha",
                price: {
                  name: "USD",
                  amount: 36,
                  currency: 1,
                },
                created_at: '2024-01-29 19:33',
              },
      ]


  return (
    <Row className="border border-2 mb-4 justify-content-center">
    {/* <Col xs={12} className="border border-2 mt-3 d-flex justify-content-xl-around align-items-center flex-wrap"> */}
    {/* <Col xs={12} className="border border-2 mt-3 py-3 d-flex justify-content-around align-items-center flex-wrap"> */}
        {/* <Col xs={12} xl={3} className="d-flex justify-content-around align-items-center"> */}
        {/* SHAPE_LIST === shape ? 12 : 3 */}


        {/* {dataProducts?.map((item) => {
            return (
                <Col key={item?.id}
            xs={12} xl={SHAPE_LIST === shape ? 12 : 3} 
            lg={SHAPE_LIST === shape ? 12 : 4} 
            md={SHAPE_LIST === shape ? 12 : 6} 
            sm={SHAPE_LIST === shape ? 12 : 7} className="my-1">
            <Product item={item} shape={shape}/>
        </Col>
            )
        })} */}



{/* {products?.map((product) => {
            return (
                <Col key={product?.id}
            xs={12} xl={SHAPE_LIST === shape ? 12 : 3} 
            lg={SHAPE_LIST === shape ? 12 : 4} 
            md={SHAPE_LIST === shape ? 12 : 6} 
            sm={SHAPE_LIST === shape ? 12 : 7} className="my-1">
            <Product product={product} shape={shape}/>
        </Col>
            )
        })} */}


        {products?.length > 0 ?
          products?.map((product) => {
            return (
                <Col key={product?.id}
            xs={12} xl={SHAPE_LIST === shape ? 12 : 3} 
            lg={SHAPE_LIST === shape ? 12 : 4} 
            md={SHAPE_LIST === shape ? 12 : 6} 
            sm={SHAPE_LIST === shape ? 12 : 7} className="my-1">
            <Product random={random} owner={false} product={product} shape={shape}/>
        </Col>
            )
        })
        :
        <Col className="d-flex align-items-center justify-content-center" style={{height: "60vh"}}>
            <Empty description="No data" className="fw-bold"/>
        </Col>
        }



        {/* <Col 
            xs={12} xl={SHAPE_LIST === shape ? 12 : 3} 
            lg={SHAPE_LIST === shape ? 12 : 4} 
            md={SHAPE_LIST === shape ? 12 : 6} 
            sm={SHAPE_LIST === shape ? 12 : 7} className="my-1">
            <Product shape={shape}/>
        </Col>
        <Col 
            xs={12} xl={SHAPE_LIST === shape ? 12 : 3} 
            lg={SHAPE_LIST === shape ? 12 : 4} 
            md={SHAPE_LIST === shape ? 12 : 6} 
            sm={SHAPE_LIST === shape ? 12 : 7} className="my-1">
            <Product shape={shape}/>
        </Col>
        <Col 
            xs={12} xl={SHAPE_LIST === shape ? 12 : 3} 
            lg={SHAPE_LIST === shape ? 12 : 4} 
            md={SHAPE_LIST === shape ? 12 : 6} 
            sm={SHAPE_LIST === shape ? 12 : 7} className="my-1">
            <Product shape={shape}/>
        </Col>
        <Col 
            xs={12} xl={SHAPE_LIST === shape ? 12 : 3} 
            lg={SHAPE_LIST === shape ? 12 : 4} 
            md={SHAPE_LIST === shape ? 12 : 6} 
            sm={SHAPE_LIST === shape ? 12 : 7} className="my-1">
            <Product shape={shape}/>
        </Col> */}
    {/* </Col> */}
    </Row>
  )
}

export default Products